/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum CategoryTypes {
  CATEGORY_REQUEST = '@CATEGORY_REQUEST',
  CATEGORY_REQUEST_SUCCCES = ' CATEGORY_REQUEST_SUCCCES',
  CATEGORY_REQUEST_FAILURE = 'CATEGORY_REQUEST_FAILURE',
}

export interface CategoryState {
  codigo: number;
  nome: string;
  escritorio: boolean;
}

export interface CategoryStateReducer{
  readonly data: Array<CategoryState>;
}

export const SET_CATEGORY = 'SET_CATEGORY';

interface SetCategory{
  type: typeof SET_CATEGORY;
  payload: Array<CategoryState>;
}

interface RequestCategory{
  type: typeof CategoryTypes.CATEGORY_REQUEST;
}

export type CategoryActionTypes = | SetCategory | RequestCategory
